/*
 * Task 04 — Disable carousel scroll-hijack (desktop)
 * --------------------------------------------------
 * Two theme mechanisms capture the vertical mouse wheel and stop the page
 * from scrolling while the cursor is over them:
 *   1. Product cards' "hover slider" ([data-hover-slider],
 *      .product-item__bg__slider) — wheel-swipes the card images.
 *   2. Horizontal grid-slider carousels ([data-grid-slider] / .grid--slider,
 *      e.g. the "כיצד תרצו לשפר את איכות החיים שלכם?" benefits carousel in the
 *      boa-my-mashroom section) — these have overflow-x:auto with horizontal
 *      overflow, and the theme maps deltaY -> horizontal scroll, eating the
 *      page's vertical scroll (QA Round 1: "three wheel ticks leave the page
 *      at the same scroll position; the scroll hijack is still there").
 * Both are bound in the off-limits minified theme.js.
 *
 * Fix (additive): a capture-phase wheel listener on the document runs BEFORE
 * the slider's own handler and stops propagation for wheel events over a
 * hover-slider, so that handler never runs, never preventDefaults, and native
 * page scrolling works normally. The listener is passive (only calls
 * stopImmediatePropagation, never preventDefault) and is scoped to
 * [data-hover-slider] targets, so nothing else is affected. Image swapping on
 * hover (mousemove) is unchanged; only wheel-swiping of card images is
 * dropped, which is the intended trade-off ("disable scroll capture").
 *
 * Verified with a dispatched cancelable wheel: with this listener installed,
 * defaultPrevented flips to false (page scroll restored).
 *
 * To remove: delete this file and its <script> in layout/theme.liquid.
 */
(function () {
  'use strict';
  if (!('closest' in Element.prototype)) return;

  // Any element whose wheel handler steals the page's vertical scroll.
  var HIJACK_SELECTOR = '[data-hover-slider], [data-grid-slider], .grid--slider';

  document.addEventListener(
    'wheel',
    function (e) {
      var t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (!t) return;
      var slider = t.closest(HIJACK_SELECTOR);
      if (!slider) return;
      // Let a genuinely vertical carousel (its own vertical overflow) keep the
      // wheel; only reclaim it for horizontal carousels / hover sliders, whose
      // wheel-capture blocks the page from scrolling vertically.
      if (slider.scrollHeight - slider.clientHeight > 4) return;
      // Run before the theme's capturing handler so it never preventDefaults;
      // native vertical page scroll is restored. Horizontal nav via arrows/drag
      // still works — only wheel-capture is dropped (the intended trade-off).
      e.stopImmediatePropagation();
    },
    { capture: true, passive: true }
  );
})();
